import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { useContext } from 'react';
import Icon from '../../icon';
import { faChevronLeft, faChevronRight } from '../../icon/sets/regular';
import StyledButton from './StepButton.styles';
import PaginationContext from '../data/PaginationContext';

var StepButton = function StepButton(props) {
  var pageNumber = props.pageNumber,
      text = props.text,
      paginationInfo = props.paginationInfo,
      domProps = _objectWithoutProperties(props, ["pageNumber", "text", "paginationInfo"]);

  var _ref = useContext(PaginationContext) || paginationInfo,
      page = _ref.page;

  var isPrev = text === '<';
  var icon = isPrev ? faChevronLeft : faChevronRight;
  var isHidden = pageNumber === page;
  return /*#__PURE__*/React.createElement(StyledButton, _extends({
    isHidden: isHidden,
    pageNumber: pageNumber
  }, domProps), /*#__PURE__*/React.createElement(Icon, {
    icon: icon
  }));
};

export default StepButton;